import { createStore, Store, useStore as baseUseStore } from 'vuex'
import { InjectionKey } from 'vue'

import State from '@/store/state'
import mutations from '@/store/mutations'
import actions from '@/store/actions'
import getters from '@/store/getters'
import subscription from '@/store/modules/subscription'
import users from '@/store/modules/users'
import departments from './modules/departments'
import roles from './modules/roles'

export const key: InjectionKey<Store<State>> = Symbol('store')

// TODO Divide into modules
export const store = createStore<State>({
  modules: {
    subscription,
    users,
    departments,
    roles
  },
  state: new State(),
  mutations,
  actions,
  getters
})

export function useStore () {
  return baseUseStore(key)
}
